/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNewArrivalStoriesResponseCondition
 */
export interface GetNewArrivalStoriesResponseCondition {
    /**
     * 
     * @type {string}
     * @memberof GetNewArrivalStoriesResponseCondition
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof GetNewArrivalStoriesResponseCondition
     */
    skip: number;
    /**
     * 
     * @type {number}
     * @memberof GetNewArrivalStoriesResponseCondition
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof GetNewArrivalStoriesResponseCondition
     */
    sort: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewArrivalStoriesResponseCondition
     */
    order: string;
}

export function GetNewArrivalStoriesResponseConditionFromJSON(json: any): GetNewArrivalStoriesResponseCondition {
    return GetNewArrivalStoriesResponseConditionFromJSONTyped(json, false);
}

export function GetNewArrivalStoriesResponseConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNewArrivalStoriesResponseCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'skip': json['skip'],
        'limit': json['limit'],
        'sort': json['sort'],
        'order': json['order'],
    };
}

export function GetNewArrivalStoriesResponseConditionToJSON(value?: GetNewArrivalStoriesResponseCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'skip': value.skip,
        'limit': value.limit,
        'sort': value.sort,
        'order': value.order,
    };
}

